export function initUploader(root) {
    const button = root.querySelector("#inko-upload-button");

    const input = root.querySelector("#inko-file-input");

    button.addEventListener("click", () => {
        input.click();
    });

    input.addEventListener("change", () => {
        const file = input.files?.[0];

        if (!file) {
            return;
        }

        window.dispatchEvent(
            new CustomEvent("inko:asset-selected", {
                detail: file,
            }),
        );
    });
}
